module.exports = __webpack_public_path__ + "static/img/Bo-Allan.d83e5f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bo-Allan.jpg
// module id = euEh
// module chunks = 0